import apiClient from './api';
import API_ENDPOINTS from './endpoints';
export const gastronomyService = {
    getAllRestaurants(params = {}) {
        // Usar el endpoint de locations con tipo restaurant ya que es el que funciona
        return apiClient.get(API_ENDPOINTS.LOCATIONS.BY_TYPE('restaurant'), params);
    },
    getRestaurantById(id) {
        return apiClient.get(API_ENDPOINTS.GASTRONOMY.BY_ID(id));
    },
    getRestaurantsByRegion(region, params = {}) {
        return apiClient.get(`/api/restaurants/region/${encodeURIComponent(region)}`, params);
    },
    getRestaurantsByCuisine(cuisine, params = {}) {
        return apiClient.get(`/api/restaurants/cuisine/${encodeURIComponent(cuisine)}`, params);
    },
    searchRestaurants(query, filters = {}) {
        return apiClient.get('/api/restaurants/search', { q: query, ...filters });
    },
    getFeaturedRestaurants() {
        return apiClient.get('/api/restaurants/featured');
    },
    // Función helper para transformar GastronomyItem a RestaurantCardData
    transformToRestaurantCard(restaurant) {
        const mainImage = restaurant.images.find(img => img.is_main) || restaurant.images[0];
        return {
            id: restaurant.id,
            title: restaurant.name,
            cuisine: restaurant.cuisine_type,
            location: restaurant.place.name,
            image: mainImage?.image_url || '/images/default-restaurant.jpg',
            description: restaurant.description
        };
    }
};
export default gastronomyService;
